import { Component, Inject, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

export interface AlertData {
  header?: string;
  title?: string;
  description?: string;
  body?: string;
  yesLabel?: string;
  noLabel?: string;
}

@Component({
  selector: 'pulse-alert',
  templateUrl: './alert.component.html',
  styleUrls: ['./alert.component.scss'],
})
export class AlertComponent {
  yesLabel: string;
  noLabel: string;

  constructor(
    public dialogRef: MatDialogRef<AlertComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: AlertData
  ) {
    this.yesLabel = this.data.yesLabel || 'Ok';
    this.noLabel = this.data.noLabel || '';
  }

  cancelDialog(): void {
    this.dialogRef.close({ confirmed: false });
  }

  yesDialog(): void {
    this.dialogRef.close({ confirmed: true });
  }
}
